<template>
  <div class="create_wrapper fadeIn">
    <!-- Start Breadcrumb -->
    <Breadcrumb :items="items" />
    <!-- End Breadcrumb -->

    <div class="custom_card">
      <div class="card-header">
        <h4 class="card-title">{{ $t("addNew") }}</h4>
      </div>
      <!-- {{data.intro}} -->
      <!-- ==== Start Form ==== -->
      <form @submit.prevent="validateCreateForm">
        <div class="container">
          <div class="row justify-content-between product">
            <div class="row py-3 gap-3">
              <v-expansion-panels>
                <!-- ======= Start solution Main Section =======  -->
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <h5>السكشن الاساسي</h5>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <div class="row">
                      <!--    Main Image Input -->
                      <div class="col-lg-12 py-0">
                        <div class="col-6 me-auto">
                          <template v-if="data.intro.image">
                            <uplode-image
                              :data_src="data.intro.image"
                              @inputChanged="uploadIntroImage($event)"
                              placeHolder=" أضف صورة"
                            ></uplode-image>
                          </template>
                          <template v-else>
                            <uplode-image
                              @inputChanged="uploadIntroImage($event)"
                              placeHolder=" أضف صورة"
                            ></uplode-image>
                          </template>
                        </div>
                      </div>
                      <div class="col-lg-6 py-0">
                        <div class="input_wrapper top_label">
                          <input
                            type="text"
                            class="form-control"
                            @input="helper_checkIfInputIsEmpty"
                            @keypress="isArabic"
                            v-model.trim="data.intro.alt_image_ar"
                          />
                          <label for="name_input" class="form-label"
                            >النص البديل للصورة (عربي)</label
                          >
                        </div>
                      </div>
                      <div class="col-lg-6 py-0">
                        <div class="input_wrapper top_label">
                          <input
                            type="text"
                            class="form-control"
                            @input="helper_checkIfInputIsEmpty"
                            @keypress="isEnglish"
                            v-model.trim="data.intro.alt_image_en"
                          />
                          <label for="name_input" class="form-label"
                            >النص البديل للصورة (انجليزي)</label
                          >
                        </div>
                      </div>
                      <!--  Name Input -->
                      <div class="col-lg-6 py-0">
                        <div class="input_wrapper top_label">
                          <input
                            type="text"
                            class="form-control"
                            @input="helper_checkIfInputIsEmpty"
                            @keypress="isArabic"
                            v-model.trim="data.intro.title_ar"
                          />
                          <label for="name_input" class="form-label"
                            >العنوان (عربي)</label
                          >
                        </div>
                      </div>
                      <div class="col-lg-6 py-0">
                        <div class="input_wrapper top_label">
                          <input
                            type="text"
                            class="form-control"
                            @keypress="isEnglish"
                            v-model.trim="data.intro.title_en"
                          />
                          <label for="name_input" class="form-label">
                            العنوان(انجليزي )</label
                          >
                        </div>
                      </div>
                      <!-- solution description Input -->

                      <div class="col-lg-6 py-0">
                        <div class="input_wrapper top_label">
                          <label for="textarea_1" class="form-label">
                            المحتوي (عربي)</label
                          >
                          <textarea
                            class="form-control"
                            rows="4"
                            @keypress="isArabic"
                            v-model="data.intro.description_ar"
                          ></textarea>
                        </div>
                      </div>
                      <div class="col-lg-6 py-0">
                        <div class="input_wrapper top_label">
                          <label for="textarea_1" class="form-label">
                            المحتوي (انجليزي)</label
                          >
                          <textarea
                            class="form-control"
                            rows="4"
                            @keypress="isEnglish"
                            v-model="data.intro.description_en"
                          ></textarea>
                        </div>
                      </div>
                      <!--  Name Input ksa -->
                      <div class="col-lg-6 py-0">
                        <div class="input_wrapper top_label">
                          <input
                            type="text"
                            class="form-control"
                            @input="helper_checkIfInputIsEmpty"
                            @keypress="isArabic"
                            v-model.trim="data.intro.title_ar_ksa"
                          />
                          <label for="name_input" class="form-label"
                            >العنوان (عربي) السعودية</label
                          >
                        </div>
                      </div>
                      <div class="col-lg-6 py-0">
                        <div class="input_wrapper top_label">
                          <input
                            type="text"
                            class="form-control"
                            @keypress="isEnglish"
                            v-model.trim="data.intro.title_en_ksa"
                          />
                          <label for="name_input" class="form-label">
                            العنوان(انجليزي ) السعودية</label
                          >
                        </div>
                      </div>
                      <!-- solution description Input -->

                      <div class="col-lg-6 py-0">
                        <div class="input_wrapper top_label">
                          <label for="textarea_1" class="form-label">
                            المحتوي (عربي) السعودية</label
                          >
                          <textarea
                            class="form-control"
                            rows="4"
                            @keypress="isArabic"
                            v-model="data.intro.description_ar_ksa"
                          ></textarea>
                        </div>
                      </div>
                      <div class="col-lg-6 py-0">
                        <div class="input_wrapper top_label">
                          <label for="textarea_1" class="form-label">
                            المحتوي (انجليزي) السعودية</label
                          >
                          <textarea
                            class="form-control"
                            rows="4"
                            @keypress="isEnglish"
                            v-model="data.intro.description_en_ksa"
                          ></textarea>
                        </div>
                      </div>
                      <h5>المعلومات المتعلقة بسنين الخبرة</h5>
                      <div
                        class="row"
                        v-for="(feature, index) in data.intro.features"
                        :key="index"
                      >
                        <hr
                          role="separator"
                          aria-orientation="horizontal"
                          class="v-divider theme--dark col-12 my-10"
                        />
                        <div class="col-lg-12 py-0">
                          <div class="col-6 me-auto">
                            <template v-if="feature.icon">
                              <uplode-image
                                :data_src="feature.icon"
                                @inputChanged="uploadIntroFeatureImage($event)"
                                placeHolder=" أضف صورة"
                              ></uplode-image>
                            </template>
                            <template v-else>
                              <uplode-image
                                @inputChanged="uploadIntroFeatureImage($event)"
                                placeHolder=" أضف صورة"
                              ></uplode-image>
                            </template>
                          </div>
                        </div>

                        <!-- AR Data -->
                        <div class="col-lg-6 py-0">
                          <div class="input_wrapper top_label">
                            <input
                              type="text"
                              class="form-control"
                              @input="helper_checkIfInputIsEmpty"
                              @keypress="isArabic"
                              v-model.trim="feature.title_ar"
                            />
                            <label for="name_input" class="form-label"
                              >الوصف (عربي)</label
                            >
                          </div>
                        </div>
                        <div class="col-lg-6 py-0">
                          <div class="input_wrapper top_label">
                            <input
                              type="text"
                              class="form-control"
                              @input="helper_checkIfInputIsEmpty"
                              @keypress="isEnglish"
                              v-model.trim="feature.title_en"
                            />
                            <label for="name_input" class="form-label"
                              >الوصف (انجليزي)</label
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <!-- ======= End solution Main Section =======  -->
                <v-expansion-panel
                  v-for="(section, index) in data.sections"
                  :key="index"
                >
                  <!-- ======= Start solution General Features  Section =======  -->
                  <v-expansion-panel-header v-if="section.key == 'our_success'">
                    <h5>أرقامنا /نجاحتنا</h5>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content
                    v-if="section.key == 'our_success'"
                  >
                    <div class="row">
                      <div class="col-lg-12 py-0">
                        <div class="col-6 me-auto">
                          <template v-if="section.image">
                            <uplode-image
                              :data_src="section.image"
                              @inputChanged="
                                uploadSectionMainImage($event, index)
                              "
                              placeHolder=" أضف صورة"
                            ></uplode-image>
                          </template>
                          <template v-else>
                            <uplode-image
                              @inputChanged="
                                uploadSectionMainImage($event, index)
                              "
                              placeHolder=" أضف صورة"
                            ></uplode-image>
                          </template>
                        </div>
                      </div>
                      <div class="col-lg-6 py-0">
                        <div class="input_wrapper top_label">
                          <input
                            type="text"
                            class="form-control"
                            @input="helper_checkIfInputIsEmpty"
                            @keypress="isArabic"
                            v-model.trim="section.alt_image_ar"
                          />
                          <label for="name_input" class="form-label"
                            >النص البديل للصورة (عربي)</label
                          >
                        </div>
                      </div>
                      <div class="col-lg-6 py-0">
                        <div class="input_wrapper top_label">
                          <input
                            type="text"
                            class="form-control"
                            @input="helper_checkIfInputIsEmpty"
                            @keypress="isEnglish"
                            v-model.trim="section.alt_image_en"
                          />
                          <label for="name_input" class="form-label"
                            >النص البديل للصورة (انجليزي)</label
                          >
                        </div>
                      </div>
                      <!-- Project Name Input -->
                      <div class="col-lg-6 py-0">
                        <div class="input_wrapper top_label">
                          <input
                            type="text"
                            class="form-control"
                            @input="helper_checkIfInputIsEmpty"
                            @keypress="isArabic"
                            v-model.trim="section.title_ar"
                          />
                          <label for="name_input" class="form-label"
                            >العنوان (عربي)</label
                          >
                        </div>
                      </div>
                      <div class="col-lg-6 py-0">
                        <div class="input_wrapper top_label">
                          <input
                            type="text"
                            class="form-control"
                            @keypress="isEnglish"
                            v-model.trim="section.title_en"
                          />
                          <label for="name_input" class="form-label">
                            العنوان(انجليزي )</label
                          >
                        </div>
                      </div>
                      <!-- solution description Input -->

                      <div class="col-lg-6 py-0">
                        <div class="input_wrapper top_label">
                          <label for="textarea_1" class="form-label">
                            الوصف (عربي)</label
                          >
                          <textarea
                            class="form-control"
                            rows="4"
                            @keypress="isArabic"
                            v-model="section.description_ar"
                          ></textarea>
                        </div>
                      </div>
                      <div class="col-lg-6 py-0">
                        <div class="input_wrapper top_label">
                          <label for="textarea_1" class="form-label">
                            الوصف (انجليزي)</label
                          >
                          <textarea
                            class="form-control"
                            rows="4"
                            @keypress="isEnglish"
                            v-model="section.description_en"
                          ></textarea>
                        </div>
                      </div>
                      <div class="col-12 row align-items-start">
                        <div class="col-11 row justify-content-center">
                          <h6>الارقام</h6>
                          <div
                            class="row"
                            v-for="(feature, featureItem) in section.features"
                            :key="featureItem"
                          >
                            <hr
                              role="separator"
                              aria-orientation="horizontal"
                              class="v-divider theme--dark col-12 my-10"
                            />
                            <!-- AR Data -->
                            <h5>الجزء {{ index + 1 }}</h5>
                            <div class="col-lg-6 py-0">
                              <div class="input_wrapper top_label">
                                <input
                                  type="text"
                                  class="form-control"
                                  @input="helper_checkIfInputIsEmpty"
                                  @keypress="isArabic"
                                  v-model.trim="feature.title_ar"
                                />
                                <label for="name_input" class="form-label"
                                  >الرقم (عربي)</label
                                >
                              </div>
                            </div>
                            <div class="col-lg-6 py-0">
                              <div class="input_wrapper top_label">
                                <input
                                  type="text"
                                  class="form-control"
                                  @input="helper_checkIfInputIsEmpty"
                                  @keypress="isEnglish"
                                  v-model.trim="feature.title_en"
                                />
                                <label for="name_input" class="form-label"
                                  >الرقم (انجليزي)</label
                                >
                              </div>
                            </div>
                            <div class="col-lg-6 py-0">
                              <div class="input_wrapper top_label">
                                <input
                                  type="text"
                                  class="form-control"
                                  @input="helper_checkIfInputIsEmpty"
                                  @keypress="isArabic"
                                  v-model.trim="feature.description_ar"
                                />
                                <label for="name_input" class="form-label"
                                  >الوصف (عربي)</label
                                >
                              </div>
                            </div>
                            <div class="col-lg-6 py-0">
                              <div class="input_wrapper top_label">
                                <input
                                  type="text"
                                  class="form-control"
                                  @input="helper_checkIfInputIsEmpty"
                                  @keypress="isEnglish"
                                  v-model.trim="feature.description_en"
                                />
                                <label for="name_input" class="form-label"
                                  >الوصف (انجليزي)</label
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- Actions -->
                        <div class="col-lg-1 row">
                          <div
                            class="col-6 py-0"
                            v-if="section.features.length > 0"
                          >
                            <span
                              class="append"
                              @click="appendGeneralFeature()"
                            >
                              <i class="fas fa-plus-circle"></i>
                            </span>
                          </div>
                          <div
                            class="col-6 py-0"
                            v-show="section.features.length > 1"
                          >
                            <span
                              class="append"
                              @click="deleteGeneralFeature()"
                            >
                              <i class="fas fa-minus-circle"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-expansion-panel-content>
                  <!-- ======= End solution General Features  Section =======  -->

                  <!-- ======= Start solution App Features  Section =======  -->
                  <v-expansion-panel-header v-if="section.key != 'our_success'">
                    <h5>
                      {{
                        section.key == "our_mission"
                          ? "هدفنا"
                          : section.key == "vission"
                          ? "رؤيتنا"
                          : section.key == "value"
                          ? "قيمننا"
                          : ""
                      }}
                    </h5>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content
                    v-if="section.key != 'our_success'"
                  >
                    <div class="row">
                      <div class="col-lg-12 py-0">
                        <div class="col-6 me-auto">
                          <template v-if="section.image">
                            <uplode-image
                              :data_src="section.image"
                              @inputChanged="
                                uploadSectionMainImage($event, index)
                              "
                              placeHolder=" أضف صورة"
                            ></uplode-image>
                          </template>
                          <template v-else>
                            <uplode-image
                              @inputChanged="
                                uploadSectionMainImage($event, index)
                              "
                              placeHolder=" أضف صورة"
                            ></uplode-image>
                          </template>
                        </div>
                      </div>
                      <div class="col-lg-6 py-0">
                        <div class="input_wrapper top_label">
                          <input
                            type="text"
                            class="form-control"
                            @input="helper_checkIfInputIsEmpty"
                            @keypress="isArabic"
                            v-model.trim="section.alt_image_ar"
                          />
                          <label for="name_input" class="form-label"
                            >النص البديل للصورة (عربي)</label
                          >
                        </div>
                      </div>
                      <div class="col-lg-6 py-0">
                        <div class="input_wrapper top_label">
                          <input
                            type="text"
                            class="form-control"
                            @input="helper_checkIfInputIsEmpty"
                            @keypress="isEnglish"
                            v-model.trim="section.alt_image_en"
                          />
                          <label for="name_input" class="form-label"
                            >النص البديل للصورة (انجليزي)</label
                          >
                        </div>
                      </div>
                      <div class="col-lg-6 py-0">
                        <div class="input_wrapper top_label">
                          <input
                            type="text"
                            class="form-control"
                            @input="helper_checkIfInputIsEmpty"
                            @keypress="isArabic"
                            v-model.trim="section.title_ar"
                          />
                          <label for="name_input" class="form-label"
                            >العنوان (عربي)</label
                          >
                        </div>
                      </div>
                      <div class="col-lg-6 py-0">
                        <div class="input_wrapper top_label">
                          <input
                            type="text"
                            class="form-control"
                            @keypress="isEnglish"
                            v-model.trim="section.title_en"
                          />
                          <label for="name_input" class="form-label">
                            العنوان(انجليزي )</label
                          >
                        </div>
                      </div>
                      <div class="col-lg-6 py-0">
                        <div class="input_wrapper top_label">
                          <label for="textarea_1" class="form-label">
                            التفاصيل (عربي)</label
                          >
                          <textarea
                            class="form-control"
                            rows="4"
                            @keypress="isArabic"
                            v-model="section.description_ar"
                          ></textarea>
                        </div>
                      </div>
                      <div class="col-lg-6 py-0">
                        <div class="input_wrapper top_label">
                          <label for="textarea_1" class="form-label">
                            التفاصيل (انجليزي)</label
                          >
                          <textarea
                            class="form-control"
                            rows="4"
                            @keypress="isEnglish"
                            v-model="section.description_en"
                          ></textarea>
                        </div>
                      </div>
                    </div>
                  </v-expansion-panel-content>
                  <!-- ======= End solution App Features  Section =======  -->
                </v-expansion-panel>
              </v-expansion-panels>
            </div>
          </div>
        </div>
        <div class="buttons_wrapper">
          <button class="base-btn">
            {{ $t("forms.submit") }}
            <span class="btn_loader" v-if="btnIsLoading"></span>
          </button>
        </div>
      </form>
      <!-- ==== End Form ==== -->
    </div>
  </div>
</template>

<script>
export default {
  name: "Update",

  data() {
    return {
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.about.title"),
          disabled: false,
          href: "/about",
        },
        {
          text: this.$t("breadcrumb.about.update"),
          disabled: true,
          href: "",
        },
      ],

      // ========== Loading
      btnIsLoading: false,
      data: {
        intro: {
          image: null,
          title_ar: null,
          title_en: null,
          title_ar_ksa: null,
          title_en_ksa: null,
          alt_image_ar: null,
          alt_image_en: null,
          description_ar: null,
          description_en: null,
          description_ar_ksa: null,
          description_en_ksa: null,
          features: [
            {
              icon: null,
              title_ar: null,
              title_en: null,
            },
          ],
        },
        sections: [
          // our success
          {
            key: "our_success",
            name: " ارقامنا /نجحتنا",
            image: null,
            order: 1,
            alt_image_ar: null,
            alt_image_en: null,
            title_ar: null,
            title_en: null,
            description_ar: null,
            description_en: null,
            features: [
              {
                title_ar: null,
                title_en: null,
                description_ar: null,
                description_en: null,
              },
            ],
          },
          // our  mission
          {
            key: "vission",
            name: "رؤيتنا",
            order: 2,
            image: null,
            alt_image_ar: null,
            alt_image_en: null,
            title_ar: null,
            title_en: null,
            description_ar: null,
            description_en: null,
          },
          {
            key: "vission",
            name: "  رؤيتنا",
            order: 2,
            image: null,
            alt_image_ar: null,
            alt_image_en: null,
            title_ar: null,
            title_en: null,
            description_ar: null,
            description_en: null,
          },
          {
            key: "our_mission",
            name: "هدفنا",
            order: 2,
            image: null,
            alt_image_ar: null,
            alt_image_en: null,
            title_ar: null,
            title_en: null,
            description_ar: null,
            description_en: null,
          },
          {
            key: "value",
            name: "قيمنا",
            order: 2,
            image: null,
            alt_image_ar: null,
            alt_image_en: null,
            title_ar: null,
            title_en: null,
            description_ar: null,
            description_en: null,
          },
        ],
      },
    };
  },

  computed: {},

  methods: {
    // Upload Gift to intro
    uploadIntroImage(img) {
      this.data.intro.image = img;
    },
    uploadIntroFeatureImage(image) {
      this.data.intro.features[0].icon = image;
    },
    // Upload  Sections Main Image
    uploadSectionMainImage(img, index) {
      this.data.sections[index].image = img;
    },
    // General Features Append And Delete
    appendGeneralFeature() {
      this.data.sections[0].features.push({
        title_ar: null,
        title_en: null,
        description_ar: null,
        description_en: null,
      });
    },
    deleteGeneralFeature() {
      this.data.sections[0].features.splice(-1);
    },

    // Validate Data
    validateCreateForm() {
      this.btnIsLoading = true;
      let validate = false;
      if (!this.data.intro.image) {
        this.$iziToast.error({
          timeout: 2000,
          message: "أضف صورة للسكشن الاساسي  ",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.intro.title_ar) {
        this.$iziToast.error({
          timeout: 2000,
          message: "ادخل عنوان السكشن الاساسي (عربي)",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.intro.title_en) {
        this.$iziToast.error({
          timeout: 2000,
          message: "ادخل عنوان السكشن الاساسي (أنجليزي)",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.intro.description_ar) {
        this.$iziToast.error({
          timeout: 2000,
          message: "ادخل وصف  السكشن الاساسي (عربي)",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.intro.description_en) {
        this.$iziToast.error({
          timeout: 2000,
          message: "ادخل وصف السكشن الاساسي (أنجليزي)",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.intro.title_ar_ksa) {
        this.$iziToast.error({
          timeout: 2000,
          message: "ادخل عنوان السكشن الاساسي السعودية(عربي)",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.intro.title_en_ksa) {
        this.$iziToast.error({
          timeout: 2000,
          message: "ادخل عنوان السكشن الاساسي السعودية(أنجليزي)",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.intro.description_ar_ksa) {
        this.$iziToast.error({
          timeout: 2000,
          message: "ادخل وصف  السكشن الاساسي السعودية(عربي)",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.intro.description_en_ksa) {
        this.$iziToast.error({
          timeout: 2000,
          message: "ادخل وصف السكشن الاساسي السعودية (أنجليزي)",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else {
        if (validate) return;
        this.data.intro.features.map((feature) => {
          if (validate) return;
          if (!feature.icon) {
            this.$iziToast.error({
              timeout: 2000,
              message: `أدخل صورة عدد سنين الخبرة  في السكشن الاساسي `,
              position: "bottomRight",
            });
            validate = true;
            this.btnIsLoading = false;
            return;
          } else if (!feature.title_ar) {
            this.$iziToast.error({
              timeout: 2000,
              message: `أدخل وصف للمعلومات المتعلقة بسنين الخبرة (عربي ) `,
              position: "bottomRight",
            });
            validate = true;
            this.btnIsLoading = false;
            return;
          } else if (!feature.title_en) {
            this.$iziToast.error({
              timeout: 2000,
              message: `أدخل وصف للمعلومات المتعلقة بسنين الخبرة (أنجليزي ) `,
              position: "bottomRight",
            });
            validate = true;
            this.btnIsLoading = false;
            return;
          }
          return;
        });
        for (let section of this.data.sections) {
          if (validate) return;
          if (!section.image) {
            this.$iziToast.error({
              timeout: 2000,
              message: `أضف صورة لسكشن ${section.name}`,
              position: "bottomRight",
            });
            validate = true;
            this.btnIsLoading = false;
            return;
          } else if (!section.title_ar) {
            this.$iziToast.error({
              timeout: 2000,
              message: ` عنوان سكشن ${section.name} مطلوب(عربي)`,
              position: "bottomRight",
            });
            validate = true;
            this.btnIsLoading = false;
            return;
          } else if (!section.title_en) {
            this.$iziToast.error({
              timeout: 2000,
              message: ` عنوان سكشن ${section.name} مطلوب(أنجليزي)`,
              position: "bottomRight",
            });
            this.btnIsLoading = false;
            return;
          } else if (!section.description_ar) {
            this.$iziToast.error({
              timeout: 2000,
              message: ` وصف سكشن ${section.name} مطلوب(عربي)`,
              position: "bottomRight",
            });
            this.btnIsLoading = false;
            return;
          } else if (!section.description_en) {
            this.$iziToast.error({
              timeout: 2000,
              message: ` وصف سكشن ${section.name} مطلوب(أنجليزي)`,
              position: "bottomRight",
            });
            this.btnIsLoading = false;
            return;
          }
          if (section.features) {
            for (const [key, value] of Object.entries(section)) {
              validate = false;
              if (validate) return;
              if (key == "features") {
                value.map((feature, index) => {
                  if (validate) return;
                  if (!feature.title_ar) {
                    this.$iziToast.error({
                      timeout: 2000,
                      message: `الرقم في  الجزء رقم ${index + 1} في سكشن ${
                        section.name
                      } مطلوب(عربي) `,
                      position: "bottomRight",
                    });
                    this.btnIsLoading = false;
                    validate = true;
                    return;
                  } else if (!feature.title_en) {
                    this.$iziToast.error({
                      timeout: 2000,
                      message: `الرقم في  الجزء رقم ${index + 1} في سكشن ${
                        section.name
                      } مطلوب(أنجليزي) `,
                      position: "bottomRight",
                    });
                    this.btnIsLoading = false;
                    validate = true;
                    return;
                  } else if (!feature.description_ar) {
                    this.$iziToast.error({
                      timeout: 2000,
                      message: `الوصف في  الجزء رقم ${index + 1} في سكشن ${
                        section.name
                      } مطلوب(عربي) `,
                      position: "bottomRight",
                    });
                    this.btnIsLoading = false;
                    validate = true;
                    return;
                  } else if (!feature.description_en) {
                    this.$iziToast.error({
                      timeout: 2000,
                      message: `الوصف في  الجزء رقم ${index + 1} في سكشن ${
                        section.name
                      } مطلوب(أنجليزي) `,
                      position: "bottomRight",
                    });
                    this.btnIsLoading = false;
                    validate = true;
                    return;
                  }
                });
              }
            }
          }
        }
      }
      this.submitData();
      // return;
    },

    // Submit Data
    submitData() {
      const submit_data = new FormData();
      // General Data
      submit_data.append("intro[ar][title]", this.data.intro.title_ar);
      submit_data.append("intro[en][title]", this.data.intro.title_en);
      submit_data.append("intro[ar][title_ksa]", this.data.intro.title_ar_ksa);
      submit_data.append("intro[en][title_ksa]", this.data.intro.title_en_ksa);
      submit_data.append(
        "intro[ar][description]",
        this.data.intro.description_ar
      );
      submit_data.append(
        "intro[en][description]",
        this.data.intro.description_en
      );
      submit_data.append(
        "intro[ar][description_ksa]",
        this.data.intro.description_ar_ksa
      );
      submit_data.append(
        "intro[en][description_ksa]",
        this.data.intro.description_en_ksa
      );
      if (this.data.intro.alt_image_ar) {
        submit_data.append(
          `intro[ar][alt_image]`,
          this.data.intro.alt_image_ar
        );
      }
      if (this.data.intro.alt_image_en) {
        submit_data.append(
          `intro[en][alt_image]`,
          this.data.intro.alt_image_en
        );
      }
      if (this.data.intro.image.img_file) {
        submit_data.append("intro[image]", this.data.intro.image.img_file);
      }
      if (this.data.intro.features[0].icon.img_file) {
        submit_data.append(
          "intro[features][0][icon]",
          this.data.intro.features[0].icon.img_file
        );
      }
      if (this.data.intro.features[0].id) {
        submit_data.append(
          "intro[features][0][id]",
          this.data.intro.features[0].id
        );
      }
      submit_data.append(
        "intro[features][0][ar][title]",
        this.data.intro.features[0].title_ar
      );
      submit_data.append(
        "intro[features][0][en][title]",
        this.data.intro.features[0].title_en
      );
      // Sections Data
      this.data.sections.forEach((section, index) => {
        submit_data.append(`sections[${index}][key]`, section.key);
        // if(section.order){
        //   }
        submit_data.append(`sections[${index}][order]`, section.order);
        submit_data.append(
          `sections[${index}][ar][alt_image_ar]`,
          section.alt_image_ar
        );
        submit_data.append(
          `sections[${index}][en][alt_image_en]`,
          section.alt_image_en
        );
        submit_data.append(`sections[${index}][ar][title]`, section.title_ar);
        submit_data.append(`sections[${index}][en][title]`, section.title_en);
        submit_data.append(
          `sections[${index}][ar][description]`,
          section.description_ar
        );
        submit_data.append(
          `sections[${index}][en][description]`,
          section.description_en
        );
        if (section.id) {
          submit_data.append(`sections[${index}][id]`, section.id);
        }
        if (section.image.img_file) {
          submit_data.append(
            `sections[${index}][image]`,
            section.image.img_file
          );
        }
        if (section.key == "our_success") {
          section.features.forEach((feature, feature_index) => {
            submit_data.append(
              `sections[${index}][features][${feature_index}][ar][title]`,
              feature.title_ar
            );
            submit_data.append(
              `sections[${index}][features][${feature_index}][en][title]`,
              feature.title_en
            );
            if (feature.id) {
              submit_data.append(
                `sections[${index}][features][${feature_index}][id]`,
                feature.id
              );
            }
            // if Feature Has Description
            if (feature.description_en) {
              submit_data.append(
                `sections[${index}][features][${feature_index}][ar][description]`,
                feature.description_ar
              );
              submit_data.append(
                `sections[${index}][features][${feature_index}][en][description]`,
                feature.description_en
              );
            }
          });
        }
      });

      this.axios({
        method: "POST",
        url: "about_us",
        data: submit_data,
      })
        .then(() => {
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("editSuccess"),
            position: "bottomRight",
          });
          this.$router.push({ path: "/about/show" });
          this.btnIsLoading = false;
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
        });
    },
    getData() {
      this.axios({
        method: "GEt",
        url: "about_us",
      })
        .then((res) => {
          this.data = res.data.data;
          const our_mission = this.data.sections.find(
            (el) => el.key == "our_mission"
          );
          if (!our_mission) {
            this.data.sections.push({
              key: "our_mission",
              name: "هدفنا",
              order: 2,
              image: null,
              alt_image_ar: null,
              alt_image_en: null,
              title_ar: null,
              title_en: null,
              description_ar: null,
              description_en: null,
            });
          }
          const our_vission = this.data.sections.find(
            (el) => el.key == "vission"
          );
          if (!our_vission) {
            this.data.sections.push({
              key: "vission",
              name: "رؤيتنا",
              order: 3,
              image: null,
              alt_image_ar: null,
              alt_image_en: null,
              title_ar: null,
              title_en: null,
              description_ar: null,
              description_en: null,
            });
          }
          const our_value = this.data.sections.find((el) => el.key == "value");
          if (!our_value) {
            this.data.sections.push({
              key: "value",
              name: "قيمنا",
              order: 4,
              image: null,
              alt_image_ar: null,
              alt_image_en: null,
              title_ar: null,
              title_en: null,
              description_ar: null,
              description_en: null,
            });
          }

          this.btnIsLoading = false;
        })
        .catch(() => {
          // this.$iziToast.error({
          //   timeout: 2000,
          //   message: err.response.data.message,
          //   position: "bottomRight",
          // });
          this.btnIsLoading = false;
        });
    },
  },

  mounted() {
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
.product {
  .chooseImage {
    width: auto !important;
  }
}
.solution_forms_radio_inputs {
  span {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    border: 1px solid var(--mainColor-2_2);
    display: inline-block;
  }
  .solution_form {
    label {
      padding: 8px 15px;
      font-size: 14px;
      color: var(--light_gray_clr);
      border-radius: 6px;
      background: var(--white_clr);
      border: 2px solid transparent;
      cursor: pointer;
      position: relative;
      width: 100%;
      &::before {
        content: "";
        width: 30px;
        height: 30px;
        border-radius: 50%;
        border: 1px solid var(--mainColor-2_2);
        display: inline-block;
        inset: 0;
        position: absolute;
      }
      &::after {
        content: "";
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background: #fff;
        display: inline-block;
        inset: 5px;
        position: absolute;
      }
    }
    input {
      display: none;
      &:checked + label::after {
        background: var(--mainColor-2_2);
      }
    }
    .solution_image {
      width: 96%;
      display: inline-block;
      max-height: 300px;
      object-fit: cover;
      border-radius: 15px;
    }
  }
}
.border_main_color {
  border: 1px solid var(--mainColor-2_2);
  padding-block: 30px;
  border-radius: 15px;
  margin-block: 15px;
  h3 {
    margin-block-end: 10px;
  }
  .solution_image {
    width: 96%;
    display: inline-block;
    max-height: 300px;
    object-fit: cover;
    border-radius: 15px;
  }
}
.productDetails {
  border: 1px solid #339989;
  border-radius: 15px;
  padding-block: 20px;

  &.disabled {
    cursor: not-allowed;

    h3 {
      color: gray;
      font-size: 25px;
    }

    h4 {
      font-size: 21px;
      color: gray;
    }

    & > * {
      pointer-events: none;
    }
  }
}
</style>
